module.exports = __webpack_public_path__ + "static/media/crossmod-house-opt.efccdc6f.webp";